module.exports = __webpack_public_path__ + "media/images/article/2021_06-d499256efdce1218b90a7c35b1288d4f.png";